import React, { Component } from 'react'
import CreateNewAccount from './create-new-account'
import YourTelsimSim from './your-telsim-sim'
import YourPlan from './your-plan'
import YourMobile from './your-mobile'
import SetupYourProfile from './setup-your-profile'
import PaymentMethod from './payment-method'
import IdValidation from './id-validation'
import Success from "./success";
import  PostPaidPlans from './PostPaid/PostPaidPlans'
import PostPaidYourMobile from './PostPaid/PostPaidYourMobile'
import SetupYourPostPaidProfile from './PostPaid/SetUpYourPostPaidProfile'
import PostPaidPaymentMethod from './PostPaid/PostPaidPaymentMethod'
import PostPaidIdValidation from './PostPaid/PostPaidIdValidation'
import PostPaidSuccess from './PostPaid/PostPaidSuccess'

export class wizard extends Component {
    //name: "John  Smith", street: "131 Dartmouth St", city: "Boston", state: "MA", zip: "02116" 
          
    state = {
        step: 1,
        from: {
            name: '',
            street: '',
            city: '',
            state: '',
            zip: '',
        },
        to: {
            name: '',
            street: '',
            city: '',
            state: '',
            zip: '',
        },
        tabactive:'',
        postpaid:false,
        creditSim:0,
        RefernceNumber:0,
        type:"",
    };

    




   handlePostPaidChange=(input)=>{
    this.setState({postpaid:input})
   }


   handleCreditSimChange=(input)=>{
     this.setState({creditSim:input})
   }

   handleTypeChange=(input)=>{
     this.setState({type:input})
   }
      






    nextStep = () => {
        const { step } = this.state;
        this.setState({
            step: step + 1
        });
    };

    goNext = (stepNo) => {
        this.setState({
            step: stepNo
        });
    }

    gotoStep = (stepNo) => {

        if(stepNo >= '1')
        { 
            var elementExists = document.getElementById("activation_tab1");
            if(elementExists)
            {
                for(let i=2; i <= stepNo; i++){
                    if(i == 6 || i == 7 || i == 8){
                        leftmenu(6);
                    } else if(i == 9 || i == 10 || i == 11){
                        leftmenu(7);
                    } else {
                        leftmenu(i);
                    }
                    
                }
            }
        }
        function leftmenu(activetab)
        {
            document.getElementById("activation_tab"+activetab).setAttribute("data-ktwizard-state", "current");

            let nexttab= activetab+1;
            if(nexttab <=8){ document.getElementById("activation_tab"+nexttab).setAttribute("data-ktwizard-state", ""); }

            var a = document.getElementById("activation_tab"+activetab).children; 
            a[0].style.display = "flex";
            a[1].style.display = "none";

            if(activetab >1)
            {
                let prevtab=activetab-1;
                var c = document.getElementById("activation_tab"+prevtab).children; 
                c[0].style.display = "none";
                c[1].style.display = "flex";
            }
        }
        if(stepNo == 6 || stepNo == 7 || stepNo == 8){
            this.setState({step: 6 + 1});
        } else if(stepNo == 9 || stepNo == 10 || stepNo == 11){
            this.setState({step: 7 + 1});
        } else {
            this.setState({step: stepNo + 1});
        }

        
    }


    prevStep = () => {
        const { step } = this.state;
        this.setState({
            step: step - 1
        });
    };

    handleChange = (input, address) => e => {

        switch (address) {
            case 'from':
                this.setState({
                    ...this.state,
                    from: {
                        ...this.state.from,
                        [input]: e.target.value
                    }
                });
                break;
            case 'to':
                this.setState({
                    ...this.state,
                    to: {
                        ...this.state.to,
                        [input]: e.target.value
                    }
                });
                break;
            case 'cost':
                this.setState({
                    [input]: e.target.value
                })

                break;
            default:
                this.setState({
                    [input]: e.target.value
                }
                );
                break;
        }

    }

    componentDidMount() {
        const step = sessionStorage.getItem("activation_step");
         if(step){
             this.gotoStep(step)

         }
      }


    render() {




     
        const {BiometricValue} =this.props
        

        const { step } = this.state;

        let activetabstate = this.state.step;

        if(activetabstate >= '1')
        { 

            var elementExists = document.getElementById("activation_tab1");
            if(elementExists)
            {
            leftmenu(activetabstate);
            }
        }   
        
        function leftmenu(activetab)
        {
            document.getElementById("activation_tab"+activetab)?.setAttribute("data-ktwizard-state", "current");

            let nexttab= activetab+1;
            
            if (!BiometricValue) {
                if (nexttab <= 8) { document.getElementById("activation_tab" + nexttab)?.setAttribute("data-ktwizard-state", ""); }
            }
            
            var a = document.getElementById("activation_tab"+activetab)?.children; 
            a[0].style.display = "flex";
            a[1].style.display = "none";

            if(activetab >1)
            {
                let prevtab=activetab-1;
                var c = document.getElementById("activation_tab"+prevtab)?.children; 
                c[0].style.display = "none";
                c[1].style.display = "flex";
            }
        }

        


 




        switch (step) {
            case 1:
                return (
                    <CreateNewAccount
                        nextStep={this.nextStep}
                        handleChange={this.handleChange}
                        gotoStep={this.gotoStep}
                        values={this.state}
                        setBiometric={this.props?.getBiometric}
                    />
                );
            case 2:
                return (
                    <YourTelsimSim
                        nextStep={this.nextStep}
                        prevStep={this.prevStep}
                        handleChange={this.handleChange}
                        handlePostPaidChange={this.handlePostPaidChange}
                        values={this.state}
                        handleTypeChange={this.handleTypeChange}
                        setBiometric={this.props?.getBiometric}

                    />
                );
                case 3:
                    return (
                      <>
                        {this.state.postpaid? (
                          <PostPaidPlans
                            nextStep={this.nextStep}
                            prevStep={this.prevStep}
                            handleChange={this.handleChange}
                            values={this.state}
                            handlecredit={this.handleCreditSimChange}
                          />
                        ) : (
                          <YourPlan
                            nextStep={this.nextStep}
                            prevStep={this.prevStep}
                            handleChange={this.handleChange}
                            values={this.state}
                          
                          />
                        )}
                      </>
                    );
                  
            case 4:
                return (
                    <>
                        {this.state.postpaid? (
                            <PostPaidYourMobile
                                nextStep={this.nextStep}
                                prevStep={this.prevStep}
                                goNext={this.goNext}
                                handleChange={this.handleChange}
                                values={this.state}
                                setPostpaidBiometric={this.props?.getPostpaidBiometric}
                                postPaidBiometicProps= {this.props?.postPaidBiometricValue}
                                setBiometric={this.props?.getBiometric}
                            />
                        ) : (
                            <YourMobile
                                nextStep={this.nextStep}
                                prevStep={this.prevStep}
                                goNext={this.goNext}
                                handleChange={this.handleChange}
                                values={this.state}
                                setBiometric={this.props?.getBiometric}
                                biometricProps={this.props}

                            />)
                        }
                    </>

                )
            case 5:
                return (
                    <>
                        {this.state.postpaid  ? (
                            <SetupYourPostPaidProfile
                                nextStep={this.nextStep}
                                prevStep={this.prevStep}
                                handleChange={this.handleChange}
                                values={this.state}
                            />
                        ) : (
                            <SetupYourProfile
                                nextStep={this.nextStep}
                                prevStep={this.prevStep}
                                handleChange={this.handleChange}
                                values={this.state}
                            />
                        )}
                    </>
                  
                );
            case 6:
                return (
                    <>  
                   {this.state.postpaid ?(
                    < PostPaidPaymentMethod
                    nextStep={this.nextStep}
                    prevStep={this.prevStep}
                    handleChange={this.handleChange}
                    values={this.state}
                    setPostpaidBiometric={this.props?.getPostpaidBiometric}
                    postPaidBiometicProps= {this.props?.postPaidBiometricValue}
                    />
                   ):(

                    <PaymentMethod
                    nextStep={this.nextStep}
                    prevStep={this.prevStep}
                    handleChange={this.handleChange}
                    values={this.state}
                    biometricProps={this.props}
                />
                   ) }

                     </>
                );
            case 7:
                return (
                    <>
                        {this.state.postpaid ? (
                            <PostPaidIdValidation
                                nextStep={this.nextStep}
                                prevStep={this.prevStep}
                                handleChange={this.handleChange}
                                values={this.state}
                            />
                        ) : (
                            <IdValidation
                                nextStep={this.nextStep}
                                prevStep={this.prevStep}
                                handleChange={this.handleChange}
                                values={this.state}
                            />
                        )
                        }
                    </>

                );
            case 8:
                return (
                    <>
                        {this.state.postpaid ? (
                            <PostPaidSuccess
                                nextStep={this.nextStep}
                                prevStep={this.prevStep}
                                handleChange={this.handleChange}
                                values={this.state}
                            />

                        ) :
                            (
                                <Success
                                    nextStep={this.nextStep}
                                    prevStep={this.prevStep}
                                    handleChange={this.handleChange}
                                    values={this.state}
                                />
                            )
                        }
                    </>
                )
            default:
                return
        }
    }
}

export default wizard